BinderSuperExpress = window.BinderSuperExpress = (function () {
    var bindUI = function () {
        return false;

    }
    var unBindUI = function () {
        return false;
    }

    var bind = function(justLoaded) { bindUI(); }
    var unBind = function() { unBindUI(); }

    return {
        bind: bind,
        unBind: unBind,
        name: 'BinderSuperExpress',
        url: '/baltsystem/getviewset'
    }
}());

//-----------------------------------

BinderAllSuperExpress = window.BinderAllSuperExpress = (function () {
    return {
		bind: function () { BinderSuperExpress.bind() },
		unBind: function () { BinderSuperExpress.unBind() },
        name: 'BinderAllSuperExpress',
        url: '/baltsystem/getalldrawings'
    }
}());

//-----------------------------------

ScopeSuperExpress = window.ScopeSuperExpress = (function () {

    function init() {
        app.VerticalMenu.hide();
        app.Superexpress.init();
        // Superexpress.refresh();
        // liveTableTimerInit();
    }

    function dispose() {
        //TODO: nullref check
        app.Superexpress.dispose();
        return;
    }

    var start = function (justLoaded) { init(); };
    var stop = function () { dispose(); };

    return {
        start: start,
        stop: stop,
        name: 'ScopeSuperExpress',
    };
}());